export enum MyAccountMenu {
  MyInformation = 'MyInformation',
  MyCanteen = 'MyCanteen',
}
